export enum OrderParticipantTab {
  Signers = 'signers',
  Reviewers = 'reviewers',
  Receivers = 'receivers',
}
